import { render, staticRenderFns } from "./formCarteiraCobranca.vue?vue&type=template&id=1bd0ef2e&scoped=true"
import script from "./formCarteiraCobranca.vue?vue&type=script&lang=js"
export * from "./formCarteiraCobranca.vue?vue&type=script&lang=js"
import style0 from "./formCarteiraCobranca.vue?vue&type=style&index=0&id=1bd0ef2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd0ef2e",
  null
  
)

export default component.exports